import "./KitchenRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import Architecturecabinetrylayoutmastery from "./sections/Architecturecabinetrylayoutmastery";
import KitchenGallery from "./sections/KitchenGallery";
import Workflow from "./sections/Workflow";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
import StartProject, { GnciBooking } from "./sections/StartProject";

// Order (owner request Sept 17): booking form first, then completed-kitchen photos, then what a remodel can include.
// The former Hero section (./sections/Hero) is kept in the project but no longer shown.
export default function KitchenRemodelingPage() {
  return <div>
      <Header />
      <GnciBooking service="kitchen" />
      <KitchenGallery />
      <Architecturecabinetrylayoutmastery />
      <Workflow />
      <Faq />
      <StartProject />
      <Footer />
    </div>;
}